<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="员工姓名">
          <el-input placeholder="请输入员工姓名" v-model="formInline.name">
          
          </el-input>

        </el-form-item>
        <el-form-item label="员工名称">
   
          <el-input placeholder="请输入员工名称" v-model="formInline.supply_name">
      
          </el-input>
        </el-form-item>
        <el-form-item >
          <el-button size="small" type="primary" icon="el-icon-search" @click="getData">查询</el-button>
 
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-auth="'/plus/staff/index/add'">添加员工</el-button>

      <el-button size="small" icon="el-icon" type="primary" @click="importClick" v-auth="'/plus/staff/index/excel_upload'">导入</el-button>
      <el-button size="small" icon="el-icon" type="success" @click="exportClick" v-auth="'/plus/staff/index/export'">导出</el-button>

    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%"
          @selection-change="handleSelectionChange"
          v-loading="loading">
            <el-table-column type="selection"  width="45"></el-table-column>
            <el-table-column prop="numb" label="编号"></el-table-column>
            <el-table-column prop="name" label="姓名"></el-table-column>
          
            <el-table-column prop="avatarUrl" label="头像">
            <template slot-scope="scope">
              <div v-if="scope.row.image_url">
                <img :src="scope.row.image_url" width="30px" height="30px"/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="welfare" label="福利金"></el-table-column>
          <el-table-column prop="supply.name" label="员工"></el-table-column>
          <el-table-column prop="user.nickName" label="关联会员"></el-table-column>
            <el-table-column prop="mobile" label="手机号"></el-table-column>
            <el-table-column prop="time" label="入职时间"></el-table-column>
            <el-table-column prop="post" label="职位"></el-table-column>
            <el-table-column prop="gender" label="性别">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 1">男</span>
                <span v-if="scope.row.gender == 2">女</span>
              </template>
            </el-table-column>
            <el-table-column prop="status" label="入职状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">未入职</span>
                <span v-if="scope.row.status == 1">在职</span>
                <span v-if="scope.row.status == 2">离职</span>
              </template>

            </el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
           
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
               
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 100,500, 800]"
       layout="total,sizes, prev, pager, next, jumper "
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    
    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :staff_id="staff_id"  v-if="open_edit"   @close="closeEdit"></Edit>

     <!--会员充值-->
     <Upload v-if="open_upload"  @closeDialog="closeDialogFunc($event,'upload')"></Upload>
  </div>
</template>

<script>
  import StaffApi from '@/api/staff.js';
  import Add from './add.vue';
  import qs from 'qs'
  import Edit from './edit.vue';

  import Upload from '@/components/file/import';
  
  export default {
    components: {
      Add,
      Edit,
      qs,

      Upload
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          name:"",
          supply_name:""
        },

        open_add:false,
        open_edit:false,
        staff_id:"",
        open_rechage:false,
        open_upload:false,
         /*选中的*/
      multipleSelection: [],
      import_type:"staff",
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
    },
    methods: {
      rechageClick(item){
          /*打开添加*/
          this.userModel = item;
         this. open_rechage = true;
      },
        /*选择数据*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

    exportClick: function() {
        // 勾选需要导出的数据
        let ids = [];
      let params = this.multipleSelection;
      params.forEach((param)=>{
        ids.push(param.staff_id);
      })
      ids = ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.searchForm?this.searchForm:{};
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      if(ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/plus.staff.Index/export?' + qs.stringify(this.searchForm)+'&ids='+ids;
        
      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }


       
    },
     importClick:function(row){

      this.open_upload = true
    },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = this.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        self.loading = true;
        StaffApi.list(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
          });
      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.staff_id = row.staff_id;
        this.open_edit = true
      },

      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            StaffApi.del(
              {
                staff_id: row.staff_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
          /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_rechage = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }else  if (f == 'upload') {
            this.open_upload = e.openDialog;
            if (e.type == 'success') {
                  this.getData();
            }
        }
    },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/staff/index/index.vue